import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';


interface BulkOperationsToolbarProps {
  selectedCount: number;
  onExport: () => void;
  onReprocess: () => void;
  onUpdateStatus: (status: string) => void;
  onCompare: () => void;
  onClearSelection: () => void;
}

const BulkOperationsToolbar = ({
  selectedCount,
  onExport,
  onReprocess,
  onUpdateStatus,
  onCompare,
  onClearSelection
}: BulkOperationsToolbarProps) => {
  const [showStatusMenu, setShowStatusMenu] = useState(false);

  const statusOptions = [
    { value: 'pending', label: 'Marcar como Pendente' },
    { value: 'processing', label: 'Marcar como Processando' },
    { value: 'success', label: 'Marcar como Sucesso' }
  ];

  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50">
      <div className="bg-card border border-border rounded-lg shadow-lg p-4">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <Icon name="CheckSquare" size={20} color="var(--color-primary)" />
            <span className="text-sm font-medium text-foreground">
              {selectedCount} consulta{selectedCount !== 1 ? 's' : ''} selecionada{selectedCount !== 1 ? 's' : ''}
            </span>
          </div>

          <div className="h-6 w-px bg-border" />

          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              iconName="Download"
              iconPosition="left"
              onClick={onExport}
            >
              Exportar
            </Button>

            <Button
              variant="outline"
              size="sm"
              iconName="RefreshCw"
              iconPosition="left"
              onClick={onReprocess}
              disabled={selectedCount > 100}
            >
              Reprocessar
            </Button>

            <div className="relative">
              <Button
                variant="outline"
                size="sm"
                iconName="Tag"
                iconPosition="left"
                onClick={() => setShowStatusMenu(!showStatusMenu)}
              >
                Status
              </Button>
              {showStatusMenu && (
                <div className="absolute bottom-full mb-2 right-0 w-56 bg-card border border-border rounded-md shadow-lg">
                  <div className="p-2 space-y-1">
                    {statusOptions.map((option) => (
                      <button
                        key={option.value}
                        onClick={() => {
                          onUpdateStatus(option.value);
                          setShowStatusMenu(false);
                        }}
                        className="w-full text-left px-3 py-2 text-sm text-foreground hover:bg-muted rounded transition-colors"
                      >
                        {option.label}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <Button
              variant="outline"
              size="sm"
              iconName="GitCompare"
              iconPosition="left"
              onClick={onCompare}
              disabled={selectedCount < 2 || selectedCount > 5}
            >
              Comparar
            </Button>

            <div className="h-6 w-px bg-border" />

            <Button
              variant="ghost"
              size="sm"
              iconName="X"
              onClick={onClearSelection}
              aria-label="Limpar seleção"
            />
          </div>
        </div>

        {selectedCount > 100 && (
          <div className="mt-3 flex items-start gap-2 p-2 bg-warning/10 rounded">
            <Icon name="AlertTriangle" size={16} color="var(--color-warning)" className="mt-0.5 flex-shrink-0" />
            <p className="text-xs text-warning">
              Limite de 100 consultas para reprocessamento em lote. Selecione menos itens.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BulkOperationsToolbar;